export const currencies = [
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' },
  // { value: "AED", label: "AED" },
  // { value: "PKR", label: "PKR" },
];
